<script lang="ts">
  import Toast from '$components/toast/Toast.svelte';
  import { scale } from 'svelte/transition';
  import { stateToast } from '$states/toast.svelte';

  let toast = $derived(stateToast.current);
</script>

{#if toast}
  <div
    style="view-transition-name: toast;"
    transition:scale|global={{ start: 0.5, duration: 200 }}
    class="pointer-events-none fixed left-0 z-995 flex w-full justify-center p-5 top-safe">
    <div>
      <Toast {...toast} />
    </div>
  </div>
{/if}
